
import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { getagent } from '../redux/agent';
import Loader from '../components/Loader';

export default function BasicModal(props) {
  const [open, setOpen] = React.useState(props.value);
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    props.setfalser();
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const clearForm = () => {
    // Since this is a confirmation dialog, no form fields to clear.
    // Reset any state if needed (e.g., permissions if used).
  };

  const resetPassword = async () => {
    setLoading(true);
    try {
      const link = "https://embert.sisrevolution.com/api/staff/resetpassword/";
      const res = await axios.post(link, {
        _id: props.chosen.id,
        chosen: props.chosen,
      });

      if (res.status === 200) {
        setLoading(false);
        // dispatch(getagent({ data: res.data }));
        setSnackbarMessage('Password reset successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to reset password.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error resetting password.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Reset Password
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <p>
              Do you want to reset the password for{' '}
              {props.chosen.surname && props.chosen.surname + ' '}
              {props.chosen.othername && props.chosen.othername + ' '}
              {props.chosen.lastname && props.chosen.lastname}
            </p>
            <div style={{ textAlign: 'center', margin: '10px' }}>
              {loading ? (
                <Button variant="outlined" startIcon={<Loader />} disabled>
                  Loading...
                </Button>
              ) : (
                <Button variant="outlined" startIcon={<DeleteIcon />} onClick={resetPassword}>
                  Reset Password
                </Button>
              )}
            </div>
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}